import { Component, OnDestroy } from '@angular/core';
import {
  Event as rEvent,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router
} from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs';
@Component({
  selector: 'cs-web-loader',
  templateUrl: './web-loader.component.html',
  styleUrls: ['./web-loader.component.scss']
})
export class WebLoaderComponent implements OnDestroy {
  private _onDestroy$ = new Subject();
  public loadProgress: number = 0;
  public loadingRoute!: boolean;
  private _intervalCounterId?: number = 0;

  constructor(private router: Router) {
    this.router.events.pipe(takeUntil(this._onDestroy$)).subscribe(event => {
      this.navigationInterceptor(event);
    });
  }

  public ngOnDestroy(): void {
    this.loadingBarStop();
    this._onDestroy$.unsubscribe();
  }

  private navigationInterceptor(event: rEvent): void {
    if (event instanceof NavigationStart) {
      this.loadingBarStart();
    }
    if (event instanceof NavigationEnd) {
      this.loadBarComplete();
    }
    if (event instanceof NavigationCancel) {
      this.loadingBarStop();
    }
    if (event instanceof NavigationError) {
      this.loadingBarStop();
    }
  }

  public loadingBarStart(): void {
    this.loadingBarStop();
    this.loadingRoute = true;
    this._intervalCounterId = setInterval(() => {
      this.loadProgress++;
      if (this.loadProgress === 100) {
        this.loadBarComplete();
      }
    }, 50);
  }

  public loadingBarStop(): void {
    if (this._intervalCounterId) {
      clearInterval(this._intervalCounterId);
      this._intervalCounterId = undefined;
    }
  }

  public loadBarComplete(): void {
    this.loadProgress = 100;
    this.loadingBarStop();
    setTimeout(() => {
      this.loadingRoute = false;
      setTimeout(() => {
        this.loadProgress = 0;
      }, 250);
    }, 250);
  }
}
